export const uniqueDigits = { uniqueDigits: "" };

export const kpointConstants = {
  KPOINT_HOST: "videos.bajajfinserv.in",
  KPOINT_PARAMS: {
    hide: "search",
    color: "#FF6700",
    playerSkinType: "sleek",
    enableNavigation: true,
    like: true,
    trk_tracking_id: "",
    playercontrols: { hide: "" },
  },
};

export const SecondaryNavigationConstants = {
  REDIRECTION: "REDIRECTION",
  IN_PAGE_NAVIGATION: "IN_PAGE_NAVIGATION",
  CC_CARD: "cards",
  CD: "cd",
  EDU: "lsf",
};

export const PlpFilterConstants = {
  REDIRECTION: "REDIRECTION",
  FILTER: "FILTER",
  YES: "Yes",
  NO: "No",
  ACTUALLOANAMOUNT: "actualLoanAmount",
};

export const PlpResultConstants = {
  PLP_LANDING_PAGE: "PLP_LANDING_PAGE",
  PLP_RESULTS_PAGE: "PLP_RESULTS_PAGE",
  CATEGORY_CREDIT_CARD: "Credit Card",
  CARDS_FILTER: "cards",
  LOANS_FILTER: "loans",
  SUBCATEGORY_PERSONAL_LOAN: "Personal Loan",
  CLP_PAGE: "CLP_PAGE",
};

export const QRConstants = {
  // QR Key to decypt the xc parameter received in the URL
  QR_KY: "1234567890123456",
};

export const productNameConstants = {
  FD: "FD",
  SDP: "SDP",
  PL: "PL",
  PLCS: "PLCS",
  SALPL: "SALPL",
  HL: "HL",
  BLSE: "BLSE",
  UCF: "UCF",
  CC: "CC",
  EMI: "EMI",
  LAS: "LAS",
  GL: "GL",
  SMELAP: "SLAP",
  LAPPROF: "PLAP",
  LFL: "LFL",
  NCL: "NCL",
  PASA: "LI",
  NTL: "NTL",
  BLSEBT: "BLSEBT",
  ZCUC: "ZCUC",
  ZLC: "ZLC",
  ZBT: "ZBT",
  UTL: "UTL",
  LAT: "LAT",
  TLBT: "TLBT",
  TWL: "TWL",
} as const;

export const OtpVerifyModalConstants = {
  BACKSPACE: "Backspace",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  META: "Meta",
  CONTROL: "Control",
  ENTER: "Enter",
  SHIFT: "Shift",
  TAB: "Tab",
  C_KEY: "c",
  V_KEY: "v",
} as const;

export const HamBurgerMenuConstants = {
  BAJAJ_PRIME: "Bajaj Prime",
  BAJAJ_PRIME_CHICKLET_TYPE: "bajaj-prime",
};

export const PageTypes = {
  PDP: "pdp",
  CLP: "clp",
  HOMEPAGE: "homepage",
} as const;

export enum reminderConst {
  REKYC = "rekyc",
  UNPAID = "Unpaid",
  MOBILE_PREPAID = "Mobile Prepaid",
  DTH = "DTH",
  LOAN = "loan",
  INVESTMENT = "investment",
  BBPS = "bbps",
  INSURANCE = "insurance",
  MOBILE_PREPAID_UPPER = "MOBILE PREPAID",
  EMI_CARD = "emi card",
  BAJAJ_PRIME = "bajaj prime",
  FASTAG = "FASTAG",
}

export const INVALID_DATE = "Invalid Date";

export const productConstants = {
  CARDS: "Cards",
  INSURANCE: "insurance",
  DEPOSITS: "deposits",
  LOAN: "loan",
  MUTUAL_FUNDS: "mutualFunds",
  CREDIT_CARDS: "creditCards",
  SDP: "sdp",
  SUBSCRIPTION: "subscription",
  HOMEPAGE: "homepage",
  EMI_CARD: "emiCard",
  PASA: "pasa",
  CARD_SLIDES: "cardSlides",
} as const;

export const reniewFlag = {
  YES: "Y",
  NO: "N",
};

export const qrConstants = {
  NTBCUSTOMER: "NTB",
  PTBCUSTOMER: "PTB",
  ETBCUSTOMER: "ETB",
  ICORSKEYTWL: "twl",
  BACKSPACE: "Backspace",
  eventId: "GenericActivity",
  childEventId: "QRScan",
  lob: "HO00100208",
  lob_lsf: "HO00100035",
  lob_rural: "HO00100078",
  transactionStatus: "SUCCESS",
  channelCode: "B2BOffline",
  QR_CODE_WEB_PAGE: "qr-code-web-page",
  QR_CODE_RURAL_WEB_PAGE: "qr-code-rural-web-page",
  QR_CODE_LSF_WEB_PAGE: "qr-code-lsf-web-page",
};

export const LoginConstants = {
  SUCCESS: "success",
  PERPETUAL: "perpetual",
  FAILURE: "failure",
  PENDING: "pending",
};

export const DealerOfferCardsConstants = {
  QR: "qr",
  ARU: "aru",
  ONE_OFFER: "oneOffer",
  DEFAULT: "default",
  CHANNEL_QR: "QR",
};

export const BannerizationConstants = {
  TRUE: "true",
  ACTIVE: "ACTIVE",
  ONLY_MOBILE: "onlyMobile",
  ONLY_DESKTOP: "onlyDesktop",
  ONLY_LOGGED_IN: "onlyLoggedIn",
  ONLY_NON_LOGGED_IN: "onlyNonLoggedIn",
  BOTH: "both",
};

export const customerType = {
  INDIVIDUAL: "I",
  CORPORATE: "C",
  ETB: "ETB",
  PTB: "PTB",
  NTB: "NTB",
};

export const plpSubCategoryConstants = {
  PERSONAL_LOAN: "Personal Loan",
};

export const PageCategory = {
  DOCTOR_WORLD: "doctor-world",
  MSME_WORLD: "msme-world",
};

export const relationStatusType = {
  ACTIVE: "active",
  CLOSED: "closed",
  OPEN: "open",
  BLOCKED: "blocked",
  EXPIRED: "expired",
};

export const RelationTypes = {
  LOAN: "loan",
  INSURANCE: "insurance",
  DEPOSIT: "deposits",
  CARDS: "Cards",
  MF: "mutualFunds",
  CC: "creditCards",
  SUBSCRIPTION: "subscription",
};

export const CreditCardType = {
  RBL: "rbl",
  DBS: "dbs",
};

export const AmountLabels = {
  CRORE: "Crore",
  LAKH: "Lakh",
  THOUSAND: "Thousand",
  RS_LABEL: "₹",
};

export const MakAWish = {
  REMIORLSFOR2WHEELER: "remiORlsfOR2wheeler",
};

export const SKUProductCategory = {
  LOANS: "Loans",
  INVESTMENT: "Investment",
};

export const CoachmarkConstants = {
  MENU: "menu",
  NEW_CART: "new-cart",
  SHOPPING_CART: "shopping-cart",
  MORE: "more",
  ACCOUNT: "account",
  HOME_FILL: "home-fill",
  EMI_CARD: "emi-card",
  REWARDS: "prime ",
  NOTIFICATION: "notification",
  SEARCH: "search",
  LANGUAGE: "vernac-language",
  PRIME: "prime",
  PAY_EMIs: "pay-emi",
};

export const BFL_APP_HOME_PAGE =
  "https://bflcodepush.bajajfinserv.in/ExpAOP/P.12.1.3/dist/index.html";
export const HOMEPAGE_URL = "http://www.bajajfinserv.in";
export const VIDEO_URL = "https://assets.kpoint.com/orca/media/embed/videofront-vega.js";

export const GLCalculatorConstant = {
  GOLD_WEIGHT: "goldWeight",
  LOAN_AMOUNT: "loanAmount",
  GOLD_RATE_EXPIRY_TIME: 360,
  GOLD_RATE: "goldRate",
};

// New API constants to avoid conflict with old API cache
export const NEW_GL_API_CONSTANTS = {
  GOLD_RATE: "goldRateV2",
  KARAT_WISE_RATES: "karatWiseRatesV2",
  GOLD_RATE_EFFECTIVE_DATE: "goldRateEffectiveDateV2",
  EXPIRY_TIME: 360,
};

export const LAP_DEFAULT_DOB = "1988-12-04";
export const CROSSSELL_LAP_PRODUCT_TYPE = "SMELAP";

export const sharesColors = {
  orange: "#fcd362",
  navyBlue: "#4a6784",
  blue: "#74a9f2",
  pinkPastel: "#ffa7C7",
  brown: "#dd8b6a",
  yellow: "#faba0a",
  lightBlue: "#d3dae1",
  black: "#1a1a1a",
  greyCloud: "#f2f2f2",
  white: "#ffffff",
  greenDeep: "#067161",
  red: "#660000",
};

export const INPUT_LABEL = {
  percentage: "%",
  rupees: () => document.querySelector("body")?.getAttribute("data-currency-symbol"),
};

export const API_STATUS_CODE = {
  success: 90,
  unhandled: 99,
  noData: 91,
};

export const APP_PROMPTS = {
  IN_APP_REDIRECTION: "inAppDeepLink://",
  BAJAJ_SUPER_APP: "bajajsuperapp://",
  OPEN_APP_LOADER: "OpenProgressDialog",
  OPEN_PDF: "OpenPDF://",
  APP_SEARCH: "PWA_Search",
  HOMEPAGE: "HOMEPAGE",
  MY_ACCOUNT: "myAccount_PWA",
  CART: "cart",
  HAMBURGER: "hamburger",
  APP_VERSION: "getAppVersion://",
  GET_PDF_FROM_BASE64: "getpdffrombase64://",
  PAYMENT_SDK: "callcheckout://",
  CREATE_LOAD_MODULE: "CreateLoadModule://",
  GET_APP_TOKEN: "refreshToken", // string value is confusing here - RefreshToken is a prompt for getting the app token & not meant for refreshing token
  HARD_REFRESH_APP_TOKEN: "hardRefreshToken",
  SHARED_PREF: "SharedPref://",
  SHARE_APP: "ShareApp",
  OPEN_DIAL: "openDial://",

  CUSTOMER_DEMOG_DETAILS: "customerdemoapidata",
  SHOW_WEB_URL: "showWebURL",
  CUSTOMER_RELATIONSHIP_DETAILS: "customerRealtionshipApiData",
  ICORS_OFFER_DETAILS: "offerAPIdata",
  GO_BACK_TO_3IN1: "gobackto3in1",
  SHOW_MONETIZATION_URL: "showmonetisationurl",
  SHOW_MONETIZATION_URL_APP: "showmonetisationurlinapp",
  GET_ADVERTISING_ID: "getadvertisingidentifier",
  INTERNET_CONNECTION_CHECK: "InternetConnectionCheck",
  CHECK_HOME_INTERNET: "checkhomeinternet",
} as const;

export const journeyPlannerConstant = {
  FROM: "from",
  TO: "to",
};

export const calendarMonthConstant = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const calendarWeekdaysConstant = ["S", "M", "T", "W", "T", "F", "S"];

export const MereJourneyOffersConstants = {
  CURRENT_SELECTION: "currentselection",
  RECOMMENDED_SELECTION: "recommendedselection",
  MERE_CART: "merecart",
};

export const GameZoneConstants = {
  STATIC_GAMES: "staticgames",
  API_GAMES: "apigames",
};

export const carouselTilesConstants = {
  STATIC: "static",
  FAVOURITE_GAMES: "favouriteGames",
  CONTINUE_PLAYING_GAMES: "continuePlayingGames",
};

export const AstrologyConstant = {
  ARIES: "Aries",
  TAURUS: "Taurus",
  GEMINI: "Gemini",
  CANCER: "Cancer",
  LEO: "Leo",
  VIRGO: "Virgo",
  LIBRA: "Libra",
  SCORPIO: "Scorpio",
  SAGITTARIUS: "Sagittarius",
  CAPRICORN: "Capricorn",
  AQUARIUS: "Aquarius",
  PISCES: "Pisces",
  TODAY: "Today",
};

export const GOLD_LOAN_PDP_CUST_TYPE = {
  NTG: "NTG",
  ETG: "ETG",
};

export const API_EVENT_CODE = ["GL_PERSONAL"];

export const BinaryChoice = {
  YES: "YES",
  NO: "NO",
  ON: "ON",
  OFF: "OFF",
};

export const TOP_FUNDS_VARIATION = {
  DYNAMIC: "dynamic",
  STATIC: "static",
  ELSS: "elss",
  TAXSAVER: "taxsaver",
  BFL: "BFL",
};

export const prodCodeKeyModuleMapping = {
  FD: "DEPOSIT",
  SDP: "DEPOSIT",
  PRO_NTB_DL: "PL",
  PRO_ETB_DL: "PL",
  PRO_NTB_CA: "PL",
  PRO_ETB_CA: "PL",
  PRO_NTB_LW: "PL",
  PRO_ETB_LW: "PL",
  PRO_GCO_DL: "PL",
  PRO_GCO_CA: "PL",
  RPR_NTB_DL: "PL",
  RPR_NTB_CA: "PL",
  EMI: "EMI",
  EMIPWA: "EMI",
  "EMI-HC": "EMI",
  "EMI-VC": "EMI",
  "EMI-AC": "EMI",
  EMICARD_WB: "EMI",
  B2C: "B2C",
  SAL_GIN: "B2C",
  SAL_NO_OFFER: "B2C",
  RSL_NO_OFFER: "B2C",
  RSL_LINE: "B2C",
  SAL_PREAPPROVED: "B2C",
  RSL_PREAPPROVED: "B2C",
  PLCS_GIN: "B2C",
  RPL_STP: "B2C",
  PLCS_PREQUALIFIED: "B2C",
  RPL_FULL_UW: "B2C",
  PLPPL_PREQUALIFIED: "B2C",
  PPL_PREQUALIFIED: "B2C",
  RPPL_FUW: "B2C",
  PLCARD: "PL_EMI_CARD_USG",
  GLFRESH: "RGL",
  GLBT: "RGL",
  CREDITCARD: "CreditCard",
  CC: "CreditCard",
  CC_RBL: "CreditCard",
  CC_DBS: "CreditCard",
  PSBL: "BUSINESS_LOAN",
  PRO: "PL",
  EXTWARRANTY: "EXTENDED_WARRANTY",
  PRO_BL_NTB: "BUSINESS_LOAN",
  PSBL_NTB: "BUSINESS_LOAN",
  PSBL_OFFER: "BUSINESS_LOAN",
  PEMFR_NTB: "MEF",
  PEMFR: "MEF",
  BEMFR_NTB: "IEF",
  BEMFR: "IEF",
  BLSE: "BLSE",
  BLSE_NTB: "BLSE",
  BLSE_OFFER: "BLSE",
  PLSE_NTB: "BLSE",
  PLSE_OFFER: "BLSE",
  LAP: "LAPX",
  SMELAP_NTB: "LAPX",
  SMELAP_OFFER: "LAPX",
  LAPPROF_NTB: "LAPX",
  LAPPROF_OFFER: "LAPX",
  SMELAP_NTB_FRESH: "LAPX",
  SMELAP_OFFER_FRESH: "LAPX",
  LAPPROF_NTB_FRESH: "LAPX",
  LAPPROF_OFFER_FRESH: "LAPX",
  SMELAP_NTB_BT: "LAPX",
  SMELAP_OFFER_BT: "LAPX",
  LAPPROF_NTB_BT: "LAPX",
  LAPPROF_OFFER_BT: "LAPX",
  RPR_NTB_PHARMA: "PHARMA",
  ZBT_NTB: "UCF_ZBT",
  ZBT_OFFER: "UCF_ZBT",
  ZLC_NTB: "UCF_ZLC",
  ZLC_OFFER: "UCF_ZLC",
  ZCUC_NTB: "UCF_ZCUC",
  ZCUC_OFFER: "UCF_ZCUC",
  PSBL_ICL: "PSBL_ICL",
  PRO_ICL_DL: "ICL",
  RPR_TOPUP: "ICL",
  PRO_ICL_CA: "ICL",
  PRO_SLV_DL: "SLV",
  PRO_SLV_CA: "SLV",
  PSBL_SLV: "BL_SLV",
  LAS_SHARES: "LAS_SHARES",
  LAS_MUTUALFUND: "LAS_MUTUALFUND",
  LAS_MUTUALFUNDS: "LAS_MUTUALFUND",
  HL_NO_OFFER: "HL_FRESH",
  HL_OFFER: "HL_FRESH",
  HL_BT_NO_OFFER: "HL_BT",
  HL_BT_OFFER: "HL_BT",
  LAIP: "LAIP",
  NCL: "NCL",
  NCL_NTB: "NCL",
  NCL_OFFER: "NCL",
  HTS_LAMF: "LAS_MUTUALFUND",
  HL_FRESH: "HL_FRESH_V2",
  HL_BT: "HL_BT_V2",
  HTS_LAS: "LAS_SHARES",
  B2BURBAN: "B2B_MY_ORDERS_CART",
  B2BRURAL: "B2B_MY_ORDERS_CART",
  B2BSF: "B2B_MY_ORDERS_CART",
  TWF: "B2B_MY_ORDERS_CART",
  AFHO_NTB: "HL_FRESH_V2",
  BMAH_NTB: "HL_FRESH_V2",
  AFHO_OFFER: "HL_BT_V2",
  BMAH_OFFER: "HL_BT_V2",
  HTS_LAIP: "LAIP",
  BAJAJ_PRIME: "REWARDS",
};

export const CardFeatures = {
  PREMIUM: "premium",
  TENURE: "tenure",
  COVERAGE: "coverage",
  POLICY: "policy",
};
export const PARTNER_DATA = "partner_data";

export const DEFAULT_LANGUAGE = "English";

export const COOKIE_LANGUAGE_KEY = "langCode";

export const KYCPROCESS = {
  FACE_TO_FACE: "FACE TO FACE",
  F2F: "F2F",
  FACETOFACE: "FACETOFACE",
};

export const EmiCardStage = {
  APLF: "APLF",
  UVC: "UVC",
  CVP: "CVP",
};

export const MAPURL = {
  apple: "https://maps.apple.com",
  google: "https://maps.google.com",
};
export const BFL_APPLICATION_ERROR = "BFLApplicationError";

export const DEVICE_TYPE = {
  MWEB: "msite",
  DESKTOP: "desktop",
  WEB: "web",
  ANDROID: "Android",
  IOS: "IOS",
};

export const TW_EVENT = "TW_OFFER";
export const TW_PROD_NAME = "TWF";
export const TW_JOURNEY_NAME = "TW_NTB";
export const PDP_DETAILS = "PDP_Details";
export const NCL_JOURNEY_NAME = "NCL_NTB";
export const WHEELS_OFFER = "WHEELS_OFFER";
export const PROF_EVENT = "SME_PRO";
export const SME_OFFER_EVENT = "SME_OFFER";
export const PROF_PROD_NAME = "PRO";
export const INDIVIDUAL_CUST_TYPE = "Individual";

export const LOAN_REWARDS_COMPONENT = "Loan Rewards Component";
export const LOAN_REWARDS_COMPONENT_ERR = "Loan Rewards Component Error";
export const LOAN_REWARDS_RESPONSE = "loanRewardsResp";

export enum GL_ENTRY_TYPES {
  GLFRESH = "glfresh",
  GLBT = "glbt",
}
export enum GL_TABS {
  NEW_LOAN = "new-loan",
  BALANCE_TRANSFER = "balance-transfer",
}

export const FALLBACK_KARAT = "24";
export const INTEREST_RATE = "Interest Rate";
export const TENURE = "Tenure";

export const APP_VERSION_INAPP = "1.1,android";
export const APP_VERSION_WEB = "v2";
export const CHANNEL_INAPP = "1";
export const CHANNEL_WEB = "2";
export const DEFAULT_ENVIRONMENT = "1";
export const FEATURE_CLUSTER_ID = "ClusterTest";
export const LANG_HINDI = "Hindi";
export const LANG_ENGLISH = "English";
export const DEFAULT_PAGE_TAG = "Default";
export const DEFAULT_PAGE_ID = "HPMFAW1330";
